import { render, staticRenderFns } from "./KundenumsaetzeChartbox.vue?vue&type=template&id=23dcb352&"
import script from "./KundenumsaetzeChartbox.vue?vue&type=script&lang=js&"
export * from "./KundenumsaetzeChartbox.vue?vue&type=script&lang=js&"
import style0 from "./KundenumsaetzeChartbox.vue?vue&type=style&index=0&id=23dcb352&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports